module.exports = __webpack_public_path__ + "static/media/pooltree.041557fc.jpg";